import './video.scss';
import * as React from 'react';
const { useCallback, useState } = React;
import { lang } from '@umu/ukit-lang';
import { Editor } from '@tiptap/react';
import { Tooltip } from '../../tooltip/tooltip';
import { VideoForm } from '../../videoForm/videoForm';
import { useClickContainTarget } from '@umu/umu-react-hooks';
import { E_PLATFORM } from '../../../interface';

export const VideoMenu = (editor: Editor, platform = E_PLATFORM.PC) => {
    const [showVideoForm, setShowVideoForm] = useState(false);
    const [btnRef, setBtnRef] = useState<HTMLButtonElement | null>(null);

    const btnCallback = useCallback((node) => {
        node && setBtnRef(node as HTMLButtonElement);
    }, []);

    useClickContainTarget(
        [btnRef, '.rich-text-comp__add-video-modal', '.umu-video-selector-modal', '.pagination-bar'],
        (flag: boolean) => {
            setShowVideoForm(flag);
        },
    );

    const done = useCallback(() => {
        setTimeout(() => {
            setShowVideoForm(false);
        }, 34);
    }, []);

    const renderLinkForm = () => {
        if (!showVideoForm) {
            return null;
        }
        return (
            <VideoForm platform={platform} className="rich-text-comp__add-video-modal" editor={editor} done={done} />
        );
    };

    return (
        <Tooltip title={lang('插入视频')} key="video">
            <button className="menu-item menu__add-video" onClick={() => setShowVideoForm(true)} ref={btnCallback}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                        d="M4.16667 14.1667H15.8333V5H4.16667V14.1667ZM2.5 4.16667C2.5 3.70643 2.8731 3.33334 3.33333 3.33334H16.6667C17.1269 3.33334 17.5 3.70643 17.5 4.16667V15C17.5 15.4602 17.1269 15.8333 16.6667 15.8333H3.33333C2.8731 15.8333 2.5 15.4602 2.5 15V4.16667ZM11.9869 9.23775C12.2321 9.40291 12.2321 9.76376 11.9869 9.92892L9.39944 11.6718C9.12268 11.8582 8.75 11.6599 8.75 11.3262V7.84046C8.75 7.50677 9.12268 7.30846 9.39944 7.49488L11.9869 9.23775Z"
                        fill="#444444"
                    />
                </svg>
                {renderLinkForm()}
            </button>
        </Tooltip>
    );
};
